import type { CirclesChart } from '../circlesChart.js';
import type { CirclesVariant } from '../gameTypes.js';
import { PALETTE_VOID } from '../builtinPulseMaps/palettes.js';
import { assembleImportedCirclesChart } from './importedOsuChart.js';
import audioOnsets from './audio/invincible.onsets.json' with { type: 'json' };
import normalImported from './imported/invincible-normal.circles.json' with { type: 'json' };
import hardImported from './imported/invincible-hard.circles.json' with { type: 'json' };
import extremeImported from './imported/invincible-extreme.circles.json' with { type: 'json' };

export const INVINCIBLE_CIRCLES_VARIANTS: Record<CirclesVariant, CirclesChart> = assembleImportedCirclesChart({
  baseSlug: 'invincible',
  baseTitle: "Invincible",
  description: "DEAF KEV's 174 BPM hands-up DnB classic. The OG NCS dance banger, top-tier difficulty.",
  difficulty: 5,
  palette: PALETTE_VOID,
  audioSrc: '/audio/circles/invincible.mp3',
  attribution: "\"Invincible\" by DEAF KEV [NCS Release] - https://ncs.io/invincible",
  mapper: "nik_k",
  anchorOnsets: audioOnsets,
  imported: {
    normal: normalImported,
    hard: hardImported,
    extreme: extremeImported,
  },
  timing: {
    normal: { bpm: 203, offsetMs: 0, totalBeats: 206 },
    hard: { bpm: 203, offsetMs: 0, totalBeats: 206 },
    extreme: { bpm: 203, offsetMs: 0, totalBeats: 206 },
  },
});
